<template>
  <van-popup :value="show" position="bottom" @click-overlay="$emit('hide')">
    <van-picker show-toolbar :columns="cityColumns" @cancel="$emit('hide')" @confirm="onConfirm" @change="onChange" />
  </van-popup>
</template>
<script>
export default {
  name: '',
  props: {
    show: { type: Boolean, default: false },
  },
  data() {
    return {
      regionTree: [],
      selectedCityIdx: [0, 0, 0],
    };
  },
  computed: {
    cityColumns() {
      const { regionTree, selectedCityIdx } = this;
      if (regionTree.length === 0) return;

      const level1list = regionTree[selectedCityIdx[0]].child;
      const level2list = level1list[selectedCityIdx[1]].child;

      const result = [];
      result[0] = { values: regionTree.map((i, idx) => ({ text: i.name, idx })) };
      result[1] = { values: level1list.map((i, idx) => ({ text: i.name, idx })) };
      result[2] = { values: level2list.map((name, idx) => ({ text: name, idx })) };

      console.log(111, result);
      return result;
    },
  },
  watch: {
    show(nv, ov) {
      if (nv && nv !== ov) {
        this.regionTree.length === 0 && this.getRegionTree();
        document.body.appendChild(this.$el);
      }
    },
  },
  methods: {
    onConfirm(val, idx) {
      const { regionTree } = this;
      const selectedCityIdx = (this.selectedCityIdx = idx);

      const level0 = regionTree[selectedCityIdx[0]];
      const level1 = level0.child[selectedCityIdx[1]];
      const level2 = level1.child[selectedCityIdx[2]];
      this.$emit('confirm', [level0.name, level1.name, level2]);
      this.$emit('hide');
      console.log(val, idx, [level0, level1, level2]);
    },
    onChange(picker, values, index) {
      const { regionTree } = this;
      if (index === 0) {
        this.selectedCityIdx.splice(0, 3, values[0].idx, 0, 0);
      } else if (index === 1) {
        this.selectedCityIdx.splice(1, 2, values[1].idx, 0);
      } else if (index === 2) {
        this.selectedCityIdx.splice(2, 1, values[2].idx);
      }
    },
    getRegionTree() {
      this.$http
        .get('https://static.wkanx.com/static/cjs/address.json')
        .then(res => {
          this.regionTree = res.data.data;
          console.log(11, this.regionTree);
        })
        .catch(err => {
          console.log(22, err);
        });
    },
  },
  created() {},
  mounted() {},
  destroyed() {},
};
</script>
<style lang="scss" scoped></style>
